<template>
  <multiselect
    ref="multiselect"
    v-model="countryCodeData"
    :options="options"
    :searchable="true"
    :internal-search="false"
    :custom-label="nameCountry"
    :close-on-select="true"
    :show-labels="false"
    :placeholder="placeholder"
    class="field-input__inner form__input multiselect_country"
    :class="{'multiselect_hide-content': hideContent}"
    @search-change="onSearch"
    @select="selectOption"
    @open="openDropDown"
  >
    <span slot="noResult">Ничего не найдено</span>
  </multiselect>
</template>
<script>

import Multiselect from 'vue-multiselect';
import scrollToEl from '../../mixins/scrollToEl';
import { getters as cityRepositoryGetters, actions as cityRepositoryActions } from '../../store/city.repository';
import { getters as cityGetters } from '../../store/city.store';

// const _ = require('lodash');

export default {
  name: 'InputCountrySuggest',
  components: {
    Multiselect,
  },
  mixins: [scrollToEl],
  props: {
    defaultCity: Object, // Выбранный по умолчанию город
    token: String,
    type: {
      type: String,
      default: 'ADDRESS',
    },
    hint: {
      type: Boolean,
      default: false,
    },
    scrollOnFocus: {
      type: Boolean,
      default: false,
    },
    noSuggestionsHint: {
      type: String,
      default: 'Ничего не найдено',
    },
    geoLocation: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Город*',
    },
    typeField: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      default: '',
    },
    filtered: {
      type: String,
      default: 'noFiltered',
    },
    selectedDefaultCity: {
      type: Boolean,
      default: false,
    },
    countryCode: {
      type: [String, Number],
      default: '',
    },
    acceptableCountiesFrom: {
      type: [Array, String],
      default: '',
    },
    acceptableCountiesTo: {
      type: [Array, String],
      default: '',
    },
    countryDefault: {
      type: String,
      default: null,
    },
    showOtherCountries: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...cityGetters,
    ...cityRepositoryGetters, // cities()
    listOfCountries() {
      const countries = cityRepositoryActions.sort(cityRepositoryGetters.countries(), 'Name');
      if (this.showOtherCountries) {
        countries.push({
          name: 'Другие страны',
          code: 'other_countries',
        });
      }
      if (this.filtered === 'Reception_lap' && this.acceptableCountiesFrom.length) {
        return countries.filter((country) => this.acceptableCountiesFrom.includes(country.code));
      }
      if (this.filtered === 'Delivery_lap' && this.acceptableCountiesTo.length) {
        return countries.filter((country) => this.acceptableCountiesTo.includes(country.code));
      }
      return countries;
    },
    options() {
      return this.listOfCountries.filter((country) => country.name.toLowerCase().replace('ё', 'е').includes(this.query));
    },
  },
  watch: {
    selectedCity() {
      this.countryCodeData = this.selectedCity;
    },
    countryCode: {
      handler(countryCode) {
        if (!countryCode || (this.countryCodeData && this.countryCodeData.code === countryCode)) return;
        this.countryCodeData = this.listOfCountries.find((country) => country.code === countryCode);
        this.$emit('change-country', this.countryCodeData.code);
      },
      immediate: true,
    },
    countryCodeData(countryCodeData) {
      if (countryCodeData && countryCodeData.code) {
        this.$emit('change-country', countryCodeData.code);
        if (countryCodeData.code === 'other_countries') {
          this.countryCodeData = null;
        }
      } else {
        this.$emit('change-country', null);
      }
    },
    listOfCountries: {
      handler(val, oldVal) {
        if (val && val.length && oldVal && !oldVal.length && this.countryDefault) {
          this.$emit('change-country', this.countryDefault);
        }
      },
      immediate: true,
    },
    countryDefault: {
      handler(val, oldVal) {
        if (val && !oldVal && this.listOfCountries && this.listOfCountries.length) {
          this.$emit('change-country', val);
        }
      },
      immediate: true,
    },
    acceptableCountiesTo(acceptableCountiesTo) {
      if (this.filtered === 'Delivery_lap' && acceptableCountiesTo.length) {
        if (acceptableCountiesTo.includes(this.countryCode)) return;
        this.$emit('change-country', null);
        this.countryCodeData = null;
      }
    },
  },
  data() {
    return {
      countryCodeData: null,
      suggestCity: cityGetters.name(),
      query: '',
      hideContent: true,
    };
  },
  methods: {
    nameCountry({ name }) {
      return name;
    },
    onSearch(query) {
      this.query = (query.toLowerCase() === 'питер' || query.toLowerCase() === 'пите')
        ? 'санкт-петербург'
        : query.toLowerCase().replace('ё', 'е');
    },
    selectOption() {
      this.hideContent = true;
    },
    openDropDown() {
      this.hideContent = false;
      this.scrollToEl(this.$refs.multiselect);
    },
  },
};
</script>

<style lang="scss">
.multiselect_country.multiselect.field-input__inner {
  .multiselect__content {
    padding: 5px 0;
  }
  .multiselect__option {
    padding: 10px 14px 10px 15px;
  }
}
</style>
